import { BUILDING_TYPE, COUNTRY_CODE } from '~/lib/graphql/types';

export interface BuildingOption {
    value: BUILDING_TYPE;
    label: string;
}

const buildings: Record<string, BuildingOption> = {
    [BUILDING_TYPE.LANDED_HOUSE]: {
        value: BUILDING_TYPE.LANDED_HOUSE,
        label: 'Landed house'
    },
    [BUILDING_TYPE.OWNED_COMMERCIAL_PROPERTY]: {
        value: BUILDING_TYPE.OWNED_COMMERCIAL_PROPERTY,
        label: 'Commercial/Industrial'
    },
    [BUILDING_TYPE.CONDOMINIUM]: {
        value: BUILDING_TYPE.CONDOMINIUM,
        label: 'Condominium/Strata'
    },
    [BUILDING_TYPE.HDB_FLAT]: {
        value: BUILDING_TYPE.HDB_FLAT,
        label: 'HDB flat'
    }
};

/**
 * Return the list of building type options available for a given country.
 * Malaysia does not have HDB flats.
 */
export function listBuildings(countryCode: COUNTRY_CODE): BuildingOption[] {
    const all = Object.values(buildings);

    if (countryCode === COUNTRY_CODE.MY) {
        return all.filter((b) => b.value !== BUILDING_TYPE.HDB_FLAT);
    }

    return all;
}
